import { useMemo } from "react";
import { Page } from "~/api/model";
import { BatesLink } from "~/utils/markdownTerms";
import { useDocList } from "./useDocList";

type PageWithBates = Page & { batesNumber?: string | null };

function hasBatesNumber(
  page: Page
): page is PageWithBates & { batesNumber: string } {
  return (
    typeof (page as PageWithBates).batesNumber === "string" &&
    (page as PageWithBates).batesNumber !== ""
  );
}

export const useBatesLinks = (): BatesLink[] => {
  const { docList } = useDocList();

  const batesLinks = useMemo<BatesLink[]>(() => {
    if (!docList?.tree) return [];

    return docList.tree.flatMap((category) =>
      category.sections.flatMap((section) =>
        (section.pages ?? []).filter(hasBatesNumber).map((page) => ({
          batesNumber: page.batesNumber,
          pageId: page.id,
        }))
      )
    );
  }, [docList]);

  return batesLinks;
};
